import Reveal from "@/components/Reveal";
import { X, Check } from "lucide-react";

const before = [
  "Manual checks across spreadsheets and ad-hoc scripts",
  "Generic XML editors that don't understand ADAC rules",
  "Errors discovered after submission — late and costly",
  "No consistent QA standard between teams or projects",
];
const after = [
  "One workflow that understands the ADAC schema natively",
  "Automated validation with clear, actionable feedback",
  "Issues caught before handover, not after rejection",
  "A shared, repeatable quality standard for everyone",
];

export default function Problem() {
  return (
    <section data-testid="problem-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0033A0] font-mono">The problem</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight text-zinc-900 leading-tight">
            Generic tools and manual workflows turn ADAC XML into rework, delays, and uncertainty.
          </h2>
          <p className="mt-5 text-lg text-zinc-600 leading-relaxed">
            Councils spend hours reviewing submissions that fail late. Consultants rebuild and resubmit
            deliverables that should have passed the first time. Both sides lose time to problems that
            were preventable.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Reveal delay={0.05} className="rounded-2xl border border-zinc-200 bg-white p-8 md:p-10">
            <h3 className="font-heading text-lg font-medium text-zinc-900">Without WebADAC</h3>
            <ul className="mt-6 space-y-4">
              {before.map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm text-zinc-600">
                  <span className="shrink-0 mt-0.5 h-5 w-5 grid place-items-center rounded-full bg-red-50 text-red-500">
                    <X size={13} />
                  </span>
                  {b}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.12} className="rounded-2xl border border-[#0033A0]/20 bg-[#0033A0] p-8 md:p-10 text-white">
            <h3 className="font-heading text-lg font-medium">With WebADAC</h3>
            <ul className="mt-6 space-y-4">
              {after.map((a) => (
                <li key={a} className="flex items-start gap-3 text-sm text-blue-50">
                  <span className="shrink-0 mt-0.5 h-5 w-5 grid place-items-center rounded-full bg-white/15 text-white">
                    <Check size={13} />
                  </span>
                  {a}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
